import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import classNames from 'classnames';
import searchIcon from 'images/ic-search.png';
import * as Const from 'util/constants';
import './SearchBar.scss';
import { asyncSearchForHome } from 'actions/home';
import { asyncSearchForBundles, changeSearchForBundles } from 'actions/bundles';
import { asyncSearchForTemplates, changeSearchForTemplates } from 'actions/templates';

export class SearchBar extends Component {
  static propTypes = {
    searchForBundles: PropTypes.func
  };

  state = {
    query: ''
  };

  componentDidMount() {
    this.passQueryToState();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps !== this.props) {
      this.passQueryToState();
    }
  }

  passQueryToState() {
    const { query } = this.props;
    this.setState({ query: query || '' });
  }

  handleSubmit = event => {
    event.preventDefault();

    const { query } = this.state;
    const { searchForHome, searchForBundles, searchForTemplates, type, history } = this.props;
    switch (type) {
      case Const.TYPE_IMAGE_BUNDLES:
        history.push(`/${Const.TYPE_IMAGE_BUNDLES}/${query}`);
        searchForBundles(query);
        break;
      case Const.TYPE_AUDIO_BUNDLES:
        history.push(`/${Const.TYPE_AUDIO_BUNDLES}/${query}`);
        searchForBundles(query);
        break;
      case Const.TYPE_TEMPLATES:
        history.push(`/${Const.TYPE_TEMPLATES}/${query}`);
        searchForTemplates(query);
        break;
      default:
        history.push(`/home/${query}`);
        searchForHome(query);
    }
  };

  handleChange = event => {
    const { changeSearchForBundles, changeSearchForTemplates, type } = this.props;
    this.setState(
      {
        query: event.target.value
      },
      () => {
        if (type === Const.TYPE_TEMPLATES) changeSearchForTemplates(this.state.query);
        else changeSearchForBundles(this.state.query);
      }
    );
  };

  render() {
    const { className } = this.props;
    let placeHolder;
    switch (className) {
      case Const.TYPE_IMAGE_BUNDLES:
        placeHolder = 'Search For Image Bundle';
        break;
      case Const.TYPE_AUDIO_BUNDLES:
        placeHolder = 'Search For Audio Bundle';
        break;
      case Const.TYPE_TEMPLATES:
        placeHolder = 'Search For Template';
        break;
      default:
        placeHolder = 'Search For Bundle';
    }
    const { query } = this.state;
    return (
      <form className={classNames('search-bar d-flex align-items-center', className)} onSubmit={this.handleSubmit}>
        <input
          className="flex-grow-1"
          type="text"
          placeholder={placeHolder}
          value={query}
          onChange={this.handleChange}
        />
        <button className="flex-shrink-0">
          <img src={searchIcon} alt="" />
        </button>
      </form>
    );
  }
}

const mapStateToProps = state => {
  const { home, bundles, templates, user } = state;
  const bundleType = user.bundleType;
  let query = '';
  switch (bundleType) {
    case Const.TYPE_IMAGE_BUNDLES:
    case Const.TYPE_AUDIO_BUNDLES:
      query = bundles.searchFor || '';
      break;
    case Const.TYPE_TEMPLATES:
      query = templates.searchFor || '';
      break;
    default:
      query = home.searchFor || '';
  }
  return {
    query,
    type: bundleType
  };
};

const mapDispatchToProps = dispatch => ({
  searchForBundles: term => dispatch(asyncSearchForBundles(term)),
  changeSearchForBundles: term => dispatch(changeSearchForBundles(term)),
  searchForTemplates: term => dispatch(asyncSearchForTemplates(term)),
  changeSearchForTemplates: term => dispatch(changeSearchForTemplates(term)),
  searchForHome: term => dispatch(asyncSearchForHome(term))
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SearchBar));
